<template>
    <div class="panel-group definitions" id="definitionsAccordion">
        <div v-for="(definition, index) in definitions" :key="definition.id" class="panel panel-default">
            <div class="panel-heading">
                <h5 class="panel-title">
                    <a data-toggle="collapse" data-parent="#definitionsAccordion" :href="'#collapse' + sanitizeId(definition.term)">
                        {{ definition.term }}
                    </a>
                </h5>
            </div>
            <div :id="'collapse' + sanitizeId(definition.term)" class="panel-collapse collapse" :class="{ 'in': index === 0 }">
                <div class="panel-body">
                    {{ definition.definition }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        definitions: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    methods: {
        sanitizeId(text) {
            // Convert the term to a valid ID by removing special characters and spaces
            return text.replace(/[^a-zA-Z0-9]/g, '');
        }
    }
}
</script>

<style>
.definitions .panel-heading {
    cursor: pointer;
}
.definitions .panel-title {
    font-size: 16px;
    font-weight: 600;
}
.definitions .panel-body {
    font-size: 14px;
    line-height: 1.5;
}
</style>